import PropTypes from "prop-types";
import { SwiperSlider as Swiper, SwiperSlide } from "../ui";
import Testimonial from "./Testimonial.jsx";
import { TestimonialPropType } from "../../propTypes";

/**
 * Testimonial carousel component displaying customer testimonials in a swiper slider
 * Features autoplay and loop functionality for continuous testimonial display
 *
 * @component
 * @param {Object} props
 * @param {Array} props.testimonials - Array of testimonial objects
 */
// swiper slider settings
const settings = {
  slidesPerView: 1,
  loop: true,
  autoplay: true,
};

const TestimonialCarousel = ({ testimonials }) => {
  // Don't render if no testimonials available
  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  return (
    <div className="testimonial-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="testimonial-active nav-style-1 nav-testi-style">
              <Swiper options={settings}>
                {testimonials.map((testimonialSingle, key) => (
                  <SwiperSlide key={key}>
                    <Testimonial testimonial={testimonialSingle} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TestimonialCarousel.propTypes = {
  testimonials: PropTypes.arrayOf(TestimonialPropType),
};
export default TestimonialCarousel;
